import { customAxios } from '../../common/customAxios';

interface IPatchOpenMarketProductViewsByIdParams {
  productId: string;
  reqBody: {
    views: number;
  };
}

export const patchOpenMarketProductViewsById = ({
  productId,
  reqBody,
}: IPatchOpenMarketProductViewsByIdParams): Promise<void> => {
  return customAxios.patch(`/user-sell-tractors/${productId}/views`, reqBody);
};
